// extracted by mini-css-extract-plugin
module.exports = {"green":"#85c358","red":"#db222a","pink":"#e0276a","darkRed":"#90193e"};